import { render, staticRenderFns } from "./Origin.vue?vue&type=template&id=65d8bd39"
import script from "./Origin.vue?vue&type=script&lang=js"
export * from "./Origin.vue?vue&type=script&lang=js"
import style0 from "./Origin.vue?vue&type=style&index=0&id=65d8bd39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports